import type { Action } from '@ngrx/store';
import type { Category, CategoryUpdate, UpdateRankCategoryPayload } from '../../../interfaces/Category.interface';

export enum ActionType {
    RESET = '[RESET] RESET',
    FETCH_CATEGORIES = '[CATEGORY] FETCH CATEGORIES',
    FETCH_CATEGORIES_SUCCEEDED = '[CATEGORY] FETCH CATEGORIES SUCCEEDED',
    FETCH_CATEGORIES_FAILED = '[CATEGORY] FETCH CATEGORIES FAILED',
    CREATE_CATEGORY = '[CATEGORY] CREATE CATEGORY',
    UPDATE_CATEGORY = '[CATEGORY] UPDATE CATEGORY',
    REMOVE_CATEGORY = '[CATEGORY] REMOVE CATEGORY',
    UPDATE_RANK = '[CATEGORY] UPDATE RANK'
}

export class Reset implements Action {
    readonly type = ActionType.RESET;
}

export class FetchCategories implements Action {
    readonly type = ActionType.FETCH_CATEGORIES;
}

export class FetchCategoriesSucceeded implements Action {
    readonly type = ActionType.FETCH_CATEGORIES_SUCCEEDED;
    constructor(readonly payload: { categories: Category[] }) {}
}

export class FetchCategoriesFailed implements Action {
    readonly type = ActionType.FETCH_CATEGORIES_FAILED;
}

export class CreateCategory implements Action {
    readonly type = ActionType.CREATE_CATEGORY;
    constructor(readonly payload: { category: Category }) {}
}

export class UpdateCategory implements Action {
    readonly type = ActionType.UPDATE_CATEGORY;
    constructor(
        readonly payload: {
            categoryId: number;
            categoryUpdate: CategoryUpdate;
        }
    ) {}
}

export class RemoveCategory implements Action {
    readonly type = ActionType.REMOVE_CATEGORY;
    constructor(readonly payload: { categoryId: number }) {}
}

export class UpdateRank implements Action {
    readonly type = ActionType.UPDATE_RANK;
    constructor(readonly payload: UpdateRankCategoryPayload[]) {}
}

export type Actions =
    | Reset
    | FetchCategories
    | FetchCategoriesSucceeded
    | FetchCategoriesFailed
    | CreateCategory
    | UpdateCategory
    | RemoveCategory
    | UpdateRank;
